<template>
    <b-modal id="busModal" :hide-footer="true">
        <div id="busForm">
			<div class="formTitle">
				<svg-image image="iconBus"/>
				<h5>{{ $t("shuttle.modal.head") }}</h5>
			</div>

            <div class="groupLabel"><label>{{ $t("shuttle.modal.lpoint") }}</label></div>
            <b-row>
                <b-col>
                    <div class="point" v-html="$t('shuttle.modal.p1')">
                    </div>
                </b-col>
                <b-col>
                    <div class="point" v-html="$t('shuttle.modal.p2')">
                    </div>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <div class="point" v-html="$t('shuttle.modal.p3')">
                    </div>
                </b-col>
                <b-col>
                    <div class="point" v-html="$t('shuttle.modal.p4')">
                    </div>
                </b-col>
            </b-row>

            <div class="groupLabel"><label>{{ $t("shuttle.modal.lform") }}</label></div>
            <b-form>
                <b-form-group id="" :label="$t('shuttle.modal.fpoint')" label-for="" :description="$t('shuttle.modal.fpointdesc')">
                    <b-form-select>
                        <b-form-select-option value="JOG1">Plaza Ambarrukmo Yogyakarta</b-form-select-option> 
                        <b-form-select-option value="JOG2">Abu Bakar Ali Parking Area</b-form-select-option>
                        <b-form-select-option value="JOG3">Televisi Republik Indonesia Yogyakarta</b-form-select-option>
                        <b-form-select-option value="MGL1">Armada Town Square Magelang</b-form-select-option>
                    </b-form-select>
				</b-form-group>
                <b-form-group id="" :label="$t('shuttle.modal.freturn')" label-for="" :description="$t('shuttle.modal.freturndesc')">
                    <b-form-select>
                        <b-form-select-option value="R1">11.00 WIB (GMT+7)</b-form-select-option> 
                        <b-form-select-option value="R2">12.00 WIB (GMT+7)</b-form-select-option>
                        <b-form-select-option value="R3">13.00 WIB (GMT+7)</b-form-select-option>
                    </b-form-select>
				</b-form-group>
                <div class="clearfix">
					<b-button block type="submit" variant="primary" size="lg"><b-spinner small type="grow"></b-spinner> {{ $t("shuttle.modal.fbtn") }}</b-button>
				</div>
            </b-form>
        </div>
    </b-modal>
</template>
<script>
import SvgImage from '../components/SvgImage.vue';
export default {
    components : {  
	    SvgImage,
    },
}
</script>


// WEBPACK FOOTER //
// BusModal.vue